import { Box } from '@mui/material'
import React from 'react'

import {
  StatsTotalBiddersProperty,
  StatsTotalBidProperty,
  StatsTotalBidsProperty,
  StatsTotalBurnedProperty,
  StatsTotalFlowedProperty,
  StatsTotalMintedProperty,
  StatsTotalMintingRewardsProperty,
  StatsTotalSpentProperty,
} from '../../../Properties'
import Header from './Header'

const Details: React.FC = () => {
  return (
    <Box display="flex" flexDirection="column">
      <Header />
      <Box padding={1}>
        <StatsTotalMintedProperty />
      </Box>
      <Box padding={1}>
        <StatsTotalBidsProperty />
      </Box>
      <Box padding={1}>
        <StatsTotalBiddersProperty />
      </Box>
      <Box padding={1}>
        <StatsTotalBidProperty />
      </Box>
      <Box padding={1}>
        <StatsTotalBurnedProperty />
      </Box>
      <Box padding={1}>
        <StatsTotalFlowedProperty />
      </Box>
      <Box padding={1}>
        <StatsTotalMintingRewardsProperty />
      </Box>
      <Box padding={1}>
        <StatsTotalSpentProperty />
      </Box>
    </Box>
  )
}

export default Details
